import React from 'react';
import HelpTooltip from '../HelpTooltip';

/**
 * Anzeige des Vertriebswegs über der Tabelle (Original `#chbar` /
 * `renderChannel` 4039).
 *
 * Bewusst nur Anzeige: Der Vertriebsweg entscheidet über die Bepreisung des
 * ganzen Belegs. Umgestellt wird er ausschließlich vom Rabattschritt
 * (Palettenpreis, Stufe 2), damit hier niemand versehentlich alle Preise
 * verschiebt.
 *
 * @param {string} mode
 * @param {object} order
 * @param {?string} pendingChannel
 */
export default function ChannelBar({mode, order, pendingChannel}) {
    if (mode !== 'order' || !order || !order.channels || !order.channels.length) {
        return null;
    }

    const aktuell = pendingChannel || order.salesChannel;
    const label = (order.channels.find((c) => c.code === aktuell) || {}).label || aktuell || '—';
    const geaendert = !!(pendingChannel && pendingChannel !== order.salesChannel);

    return (
        <div className="fbar" style={{display: 'flex'}}>
            <span className="muted">Vertriebsweg:</span>{' '}
            <span className={`infochip${geaendert ? ' rec' : ''}`}>{label}</span>
            <HelpTooltip id="oe-chbar-help" placement="bottom" size={0.7}>
                Preisgruppe des Auftrags. Sie entscheidet, welche Preise und Staffeln gelten. Umgestellt wird sie
                nur über den Rabattschritt (Palettenpreis) — nicht von Hand.
            </HelpTooltip>
            {geaendert ? (
                <span className="poinfo" style={{color: 'var(--warn)', display: 'inline'}}>
                    → vom Rabatt (Palettenpreis) gesetzt · Preise werden bei „Speichern" neu berechnet
                </span>
            ) : null}
            {order.hasShipped ? (
                <span className="muted">
                    · Achtung: Teile bereits versendet — nur nicht-versendete Positionen werden neu bepreist
                </span>
            ) : null}
        </div>
    );
}
